@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [data]="ProjectStateList"
    [filterable]="true"
    (filterChange)="filterProjectStateList($event)"
    [(ngModel)]="ProjectStates"
    placeholder="Wählen Sie einen Wert aus"
    (valueChange)="valueChanged()">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="form-control"
    textField="name"
    valueField="id"
    [data]="ProjectStateList"
    [(ngModel)]="ProjectState"
    (valueChange)="valueChanged()">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
@if (uiController === UIControlTyp.InputFieldReadOnly) {
  <input class="form-control" readonly value="{{ getName() }}">
}

